export enum transactionCategory {
    unknown,
    food,
    recreation,
    transport,
    games,
    learning,
    vipps,
    other,
    investment,
    dining,
    groceries,
    home,
    pet,
    apple,
    transfer,
}
